<template>
  <div class="handle-alarm">
    <div class="blur-bg map-blur-panel"></div>
    <div v-if="handleAlarmType == 2" class="handle-alarm__title">
      设备位置坐标修改
    </div>
    <div v-else class="handle-alarm__title">创建手动告警</div>
    <div class="handle-alarm__form-area">
      <el-scrollbar class="handle-alarm__scrollbar">
        <el-form
          class="handle-alarm__form"
          ref="alarmForm"
          :model="alarmInfo"
          label-width="80px"
        >
          <el-form-item
            v-if="handleAlarmType == 2"
            prop="position"
            label="设备类型"
            label-width="80px"
          >
            <template>
              <span>{{ "【" + upDeviseData.deviceTypeName + "】" }}</span>
            </template>
          </el-form-item>
          <el-form-item
            v-if="handleAlarmType == 2"
            prop="position"
            label="设备名称"
            label-width="80px"
          >
            <template>
              <span>{{ "【" + upDeviseData.deviceName + "】" }}</span>
            </template>
          </el-form-item>
          <el-form-item
            v-if="handleAlarmType == 2"
            prop="position"
            label="初始坐标"
            label-width="80px"
          >
            <template>
              <span>{{
                "【" +
                upDeviseData.longitude +
                "】【" +
                upDeviseData.latitude +
                "】"
              }}</span>
            </template>
          </el-form-item>
          <el-form-item
            v-if="handleAlarmType == 2"
            prop="position"
            label="选中坐标"
            :rules="alarmRules.position"
            label-width="80px"
          >
            <template>
              <el-input
                readonly
                placeholder="请在地图上选择新坐标"
                v-model="alarmInfo.position"
              >
                <el-button slot="append" icon="el-icon-position"></el-button>
              </el-input>
            </template>
          </el-form-item>
          <el-form-item
            v-else
            prop="position"
            label="告警位置"
            :rules="alarmRules.position"
            label-width="80px"
          >
            <template>
              <el-input
                readonly
                v-if="!alarmInfo.position"
                placeholder="请点击地图选择位置"
                v-model="alarmInfo.position"
              >
              </el-input>
              <div v-else>
                <div>
                  经度:
                  {{ alarmInfo.position.split(",")[0] }}
                </div>
                <div>
                  纬度:
                  {{ alarmInfo.position.split(",")[1] }}
                </div>
              </div>
            </template>
          </el-form-item>
          <el-form-item
            v-if="handleAlarmType == 1"
            prop="alarmType"
            label="告警类型"
            :rules="alarmRules.alarmType"
            label-width="80px"
          >
            <template>
              <el-select
                v-model="alarmInfo.alarmType"
                placeholder="请选择告警类型"
                class="full-width"
              >
                <el-option
                  v-for="item in alarmTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item
            prop="alarmLevel"
            v-if="handleAlarmType == 1"
            label="告警级别"
            :rules="alarmRules.alarmLevel"
            label-width="80px"
          >
            <template>
              <el-select
                v-model="alarmInfo.alarmLevel"
                placeholder="请选择告警级别"
                class="full-width"
              >
                <el-option
                  v-for="item in alarmLevels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item
            prop="alarmDesc"
            v-if="handleAlarmType == 1"
            :rules="alarmRules.alarmDesc"
            label-position="top"
            label="告警描述"
            label-width="80px"
          >
            <template>
              <el-input
                v-model="alarmInfo.alarmDesc"
                placeholder="请输入告警描述"
                type="textarea"
                maxlength="200"
                show-word-limit
                rows="4"
                resize="none"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item
            label="上传图片"
            v-if="handleAlarmType == 1"
            prop="picture"
            label-width="80px"
          >
            <template>
              <div class="file-upload-area">
                <div class="file-list">
                  <div
                    class="file-item"
                    v-for="(item, index) in alarmInfo.pictureList"
                    :key="index"
                  >
                    <img
                      class="file-comp"
                      :src="$utils.Bus.imgPath(item.fileId)"
                    />
                    <div class="delete-icon" @click="pictureRemove(index)">
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                </div>
                <el-upload
                  :class="{ hideUpload: alarmInfo.pictureList.length >= 3 }"
                  :action="uploadUrl"
                  name="files"
                  list-type="picture-card"
                  accept="image/png, image/jpg, image/jpeg, image/bpm"
                  :before-upload="pictureBefore"
                  :on-exceed="pictureExceed"
                  :on-success="pictureSuccess"
                  :file-list="alarmInfo.pictureList"
                  :show-file-list="false"
                  :auto-upload="true"
                  multiple
                  :limit="3"
                  ref="uploadPicture"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </template>
          </el-form-item>
          <el-form-item
            label="上传视频"
            v-if="handleAlarmType == 1"
            prop="video"
            label-width="80px"
            ><template>
              <div class="file-upload-area">
                <div class="file-list">
                  <div
                    class="file-item"
                    v-for="(item, index) in alarmInfo.videoList"
                    :key="index"
                  >
                    <video
                      class="file-comp"
                      controls
                      :src="$utils.Bus.imgPath(item.fileId)"
                    ></video>
                    <div class="delete-icon" @click="videoRemove(index)">
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                </div>
                <el-upload
                  :class="{ hideUpload: alarmInfo.videoList.length >= 3 }"
                  :action="uploadUrl"
                  name="files"
                  list-type="picture-card"
                  accept="video/mp4"
                  :before-upload="videoBefore"
                  :on-exceed="videoExceed"
                  :on-success="videoSuccess"
                  :file-list="alarmInfo.videoList"
                  :show-file-list="false"
                  :auto-upload="true"
                  multiple
                  :limit="3"
                  ref="uploadVideo"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </div>
    <div class="handle-alarm__footer">
      <el-button @click="cancelAlarm" type="info">取消</el-button>
      <el-button type="primary" @click="confirmAlarm">确认</el-button>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic } from "$utils";
export default {
  props: {
    handleAlarmType: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    upDeviseData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      uploadUrl: api.common.batchFileload,
      alarmInfo: {
        position: "",
        alarmType: "",
        alarmLevel: "",
        alarmDesc: "",
        picture: "",
        pictureList: [],
        video: "",
        videoList: [],
      },
      alarmRules: {
        position: [
          {
            required: true,
            message: "请点击地图选择位置",
            trigger: "change",
          },
        ],
        alarmType: [
          {
            required: true,
            message: "请选择告警类型",
            trigger: "change",
          },
        ],
        alarmLevel: [
          {
            required: true,
            message: "请选择告警级别",
            trigger: "change",
          },
        ],
        alarmDesc: [
          {
            required: true,
            message: "请输入告警描述",
            trigger: "blur",
          },
        ],
      },
      alarmTypes: Dic.find("SENU004009"),
      alarmLevels: Dic.find("SENU017"),
    };
  },
  methods: {
    setAlarmPosition(position = "") {
      this.alarmInfo.position = position;
      this.$refs.alarmForm.clearValidate("position");
    },
    confirmAlarm() {
      this.$refs.alarmForm.validate((result) => {
        if (result) {
          // 创建手动告警
          if (this.handleAlarmType == 1) {
            let params = {
              desc: this.alarmInfo.alarmDesc,
              alarmType: this.alarmInfo.alarmType,
              alarmLevel: this.alarmInfo.alarmLevel,
              picUrl: (this.alarmInfo.pictureList || [])
                .map((item) => {
                  return item.fileId;
                })
                .join(","),
              videoUrl: (this.alarmInfo.videoList || [])
                .map((item) => {
                  return item.fileId;
                })
                .join(","),
              isApp: 0,
              longitude: this.alarmInfo.position.split(",")[0],
              latitude: this.alarmInfo.position.split(",")[1],
            };
            this.$fetch(api.bas.operateAlarm, params).then((response) => {
              if (response.success) {
                this.$message.success("手动告警成功");
                this.successAlarm();
              } else {
                this.$message.error(response.msgContent || "手动告警失败");
              }
            });
            // 修改位置
          } else {
            let params = {
              deviceId: this.upDeviseData.deviceId,
              longitude: this.alarmInfo.position.split(",")[0],
              latitude: this.alarmInfo.position.split(",")[1],
            };
            this.$fetch(api.bms.upDeviceCoords, params).then((response) => {
              if (response.success) {
                this.$message.success("修改成功");
                this.successAlarm();
              } else {
                this.$message.error(response.msgContent || "修改失败");
              }
            });
          }
        }
      });
    },
    successAlarm() {
      this.$refs.alarmForm.resetFields();
      this.alarmInfo.pictureList = [];
      this.alarmInfo.videoList = [];
      this.cancelAlarm(true);
      // this.$emit("successAlarm");
    },
    cancelAlarm(type) {
      this.alarmInfo.pictureList = [];
      this.alarmInfo.videoList = [];
      this.$emit("cancelAlarm", type);
      this.$refs.alarmForm.resetFields();
    },
    pictureExceed() {
      this.$message.warning("最多可上传3张图片");
    },
    pictureBefore(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小请不要超过2MB");
      }
      return isLt2M;
    },
    pictureSuccess(res) {
      this.alarmInfo.pictureList = this.alarmInfo.pictureList.concat(
        res.returnObj || []
      );
    },
    pictureRemove(index) {
      this.alarmInfo.pictureList.splice(index, 1);
    },
    videoExceed() {
      this.$message.warning("最多可上传3个视频");
    },
    videoBefore(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("视频大小请不要超过50MB");
      }
      return isLt50M;
    },
    videoSuccess(res) {
      this.alarmInfo.videoList = this.alarmInfo.videoList.concat(
        res.returnObj || []
      );
    },
    videoRemove(index) {
      this.alarmInfo.videoList.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.handle-alarm {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 16px 0;

  .file-upload-area {
    display: flex;
    flex-direction: row;
  }

  .file-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .file-item {
    margin-right: 5px;
    background-color: #ffffff;
    position: relative;

    .delete-icon {
      position: absolute;
      right: 0;
      top: 0;
      width: 30px;
      height: 30px;
      background-color: rgba($color: #000000, $alpha: 0.5);
      cursor: pointer;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.2s;

      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.8);
      }

      &:active {
        color: #aaaaaa;
      }
    }
  }

  .file-item,
  .file-comp,
  .el-upload--picture-card,
  .el-upload-list--picture-card .el-upload-list__item {
    height: 95px;
    width: 110px;
    line-height: 95px;
    margin-bottom: 5px;

    &:nth-child(3) {
      margin-right: 0;
    }
  }

  .hideUpload {
    .el-upload--picture-card {
      display: none;
    }
  }

  &__title {
    border-left: 4px solid #407aee;
    position: relative;
    line-height: 16px;
    text-align: left;
    padding-left: 10px;
    font-size: 16px;
    margin: 0px 10px 6px;
  }

  &__form-area {
    flex: 1;
    overflow: hidden;
    margin: 10px 0;
  }

  &__scrollbar {
    height: 100%;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  &__form {
    margin: 0 10px;
    @include set_theme_color(background-color, map-bg-color);
    padding: 10px;
  }

  &__footer {
    position: relative;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
